import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import config from '../Config';

const MIN_LENGTH = 3;
const DEBOUNCE_MS = 500;

/**
 * status: 'idle' | 'checking' | 'available' | 'taken' | 'error'
 * 'idle' also covers "too short to check yet" (< 3 chars).
 */
export default function useNicknameAvailability(nickname) {
    const [status, setStatus] = useState('idle');
    const requestIdRef = useRef(0);

    useEffect(() => {
        if (!nickname || nickname.length < MIN_LENGTH) {
            setStatus('idle');
            return;
        }

        setStatus('checking');
        const currentRequestId = ++requestIdRef.current;

        const timer = setTimeout(() => {
            axios.get(`${config.REACT_APP_BASE_URL}/api/v1/auth/nickname-available/${encodeURIComponent(nickname)}`)
                .then((res) => {
                    if (requestIdRef.current !== currentRequestId) return;
                    setStatus(res.data?.available ? 'available' : 'taken');
                })
                .catch(() => {
                    if (requestIdRef.current !== currentRequestId) return;
                    setStatus('error');
                });
        }, DEBOUNCE_MS);

        return () => clearTimeout(timer);
    }, [nickname]);

    return status;
}
